import Axios, { AxiosResponse } from "axios";
import GlobalConfig from "@/GlobalConfig";
import { StringDict } from "msal/lib-commonjs/MsalTypes";
import BaseService from "./BaseService";
import UserComplaintQuery from "@/models/ConsultaReclamaciones/UserComplaintQuery";
import AfpUserServiceContact from "@/models/AfpUserServiceContact";
import store from "@/store";
import User from "@/models/User";
export default class WsdlService extends BaseService<any> {
  public constructor() {
    super("Wsdl");
  }
  public async getUser(userId: string, password: string) {
    return this.post("GetUser", { user: userId, password: password });
  }
  public async GetUserContacts(userId: string) {
    return this.get(`GetUserContacts?user=${userId}`);
  }
  public async getUserData(userId: string) {
    return this.get(`GetUserData?cedula=${userId}`);
  }
  //MasterService/_umbracoMaster/0
  public async getTipoDeFondos(
    user: string,
    account: string
  ): Promise<AxiosResponse<any>> {
    const currentUser = (store.getters as any)["user"] as User;
    const body = {
      userIdentity: currentUser.userIdentityEncrypt,
      tokenUser: currentUser.TokenGenerate,
      user: "", // pid1 en el back
      account: account, // pid2 en el back
    };
    return this.post("GetTipoDeFondos", body);
  }
  public async postNotificacionAporteCel(
    ip: string,
    account: string,
    fundType: string,
    activate: boolean
  ) {
    return this.post("PostNotificacionAportesCel", {
      ip: ip,
      account: account,
      fundType: fundType,
      activate: activate,
    });
  }
  public async postNotificacionAporteEmail(
    ip: string,
    account: string,
    fundType: string,
    name: string,
    email: string,
    activate: boolean
  ) {
    return this.post("PostNotificacionAportesEmail", {
      ip: ip,
      account: account,
      fundType: fundType,
      name: name,
      email: email,
      activate: activate,
    });
  }

  public async postNotificacionBalanceCel(data: any) {
    return this.post("PostNotificacionBalanceCel", data);
  }
  public async postNotificacionBalanceEmail(data: any) {
    return this.post("PostNotificacionBalanceEmail", data);
  }
  public async GetCiudades(cityCode: string): Promise<AxiosResponse<any>> {
    return this.get(`GetCiudades?code=${cityCode}`);
  }
  public async GetSectores(
    cityCode: string,
    zoneCode: string
  ): Promise<AxiosResponse<any>> {
    return this.get(`GetSectores?cityCode=${cityCode}&zone=${zoneCode}`);
  }
  public async GetCargos(occupation: string): Promise<AxiosResponse<any>> {
    return this.get(`GetCargos?occupation=${occupation}`);
  }
  public async GetTipoDegestion(gestion: string): Promise<AxiosResponse<any>> {
    return this.get(`GetTipoDegestion?gestion=${gestion}`);
  }
  public async GetGestion(type: string): Promise<AxiosResponse<any>> {
    return this.get(`GetGestion?type=${type}`);
  }
  public async GetReclamaciones(
    userComplaintQuery: UserComplaintQuery
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetReclamaciones?userId=${userComplaintQuery.userId}&fromDate=${userComplaintQuery.fromDate}&toDate=${userComplaintQuery.toDate}`
    );
  }
  public async postReclamacion(complaint: any) {
    return this.post("postReclamacion", complaint);
  }
  public async postTipoEnvioEstadoCuenta(tipoEnvio: any) {
    return this.post("postTipoEnvioEstadoCuenta", tipoEnvio);
  }
  public async GetBalanceDeUsuario(
    tipFondo: string,
    codCuenta: string,
    fromDate: string,
    toDate: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetBalanceDeUsuario?tipFondo=${tipFondo}&codCuenta=${codCuenta}&fromDate=${fromDate}&toDate=${toDate}`
    );
  }
  public async GetValorCuota(
    tipFondo: string,
    codInvestment: number,
    date: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetValorCuota?tipFondo=${tipFondo}&codInvestment=${codInvestment}&date=${date}`
    );
  }
  public async GetValor(
    tipFondo: string,
    codInvestment: number,
    date: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetValor?tipFondo=${tipFondo}&codInvestment=${codInvestment}&date=${date}`
    );
  }
  public async GetMovimientosDeUsuario(
    tipFondo: string,
    codCuenta: string,
    fromDate: string,
    toDate: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetMovimientosDeUsuario?tipFondo=${tipFondo}&codCuenta=${codCuenta}&fromDate=${fromDate}&toDate=${toDate}`
    );
  }

  public async GetRentabilidad(
    cedula: string,
    codCuenta: string,
    fromDate: string,
    toDate: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetRentabilidad?cedula=${cedula}&codCuenta=${codCuenta}&fromDate=${fromDate}&toDate=${toDate}`
    );
  }
  public async GetRentabilidadAcumulada(
    cedula: string,
    codCuenta: string,
    toDate: string
  ): Promise<AxiosResponse<any>> {
    const currentUser = (store.getters as any)["user"] as User;

    const body = {
      userIdentity: currentUser.userIdentityEncrypt,
      tokenUser: currentUser.TokenGenerate,
      cedula: "", // pid1 en el back
      codCuenta: codCuenta, // pid2
      fecha: toDate, // pid3
    };

    return this.post("GetRentabilidadAcumulada", body);
  }
  public async GetDataCuenta(
    user: string,
    codCuenta: string
  ): Promise<AxiosResponse<any>> {
    return this.get(`GetDataCuenta?user=${user}&codCuenta=${codCuenta}`);
  }
  public async getDataEncEDC(
    tipFondo: string,
    seqCorte: string,
    codCuenta: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetDataEncEDC?tipFondo=${tipFondo}&seqCorte=${seqCorte}&codCuenta=${codCuenta}`
    );
  }
  public async GetFechaVigencia(
    tipFondo: string,
    date: string
  ): Promise<AxiosResponse<any>> {
    return this.get(`GetFechaVigencia?tipFondo=${tipFondo}&date=${date}`);
  }
  public async getDataSaldosEDC(
    lote: string,
    date: string
  ): Promise<AxiosResponse<any>> {
    return this.get(`getDataSaldosEDC?lote=${lote}&date=${date}`);
  }
  public async GetDataCortesEDC(
    tipFondo: string,
    codCuenta: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetDataCortesEDC?tipFondo=${tipFondo}&codCuenta=${codCuenta}`
    );
  }
  public async getDataConceptosEDC(
    stipFondo: string,
    scodCuenta: string,
    sfecCorte: string,
    sLote: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetDataConceptosEDC?stipFondo=${stipFondo}&scodCuenta=${scodCuenta}&sfecCorte=${sfecCorte}&sLote=${sLote}`
    );
  }
  public async getDataMovimtosEDC(
    stipFondo: string,
    scodCuenta: string,
    sfecDesde: string,
    sfecHasta: string,
    sEmision: string,
    sLote: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetDataMovimtosEDC?stipFondo=${stipFondo}&scodCuenta=${scodCuenta}&sfecDesde=${sfecDesde}&sfecHasta=${sfecHasta}&sEmision=${sEmision}&sLote=${sLote}`
    );
  }
  public async getComision(
    tipFondo: string,
    codCuenta: string,
    fromDate: string,
    toDate: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetComision?tipFondo=${tipFondo}&codCuenta=${codCuenta}&fromDate=${fromDate}&toDate=${toDate}`
    );
  }
  public async GetMinMaxValues(tipFondo: string): Promise<AxiosResponse<any>> {
    return this.get(`GetMinMaxValues?tipFondo=${tipFondo}`);
  }
  public async GetAportesDeUsuario(
    tipFondo: string,
    codCuenta: string,
    fromDate: string,
    toDate: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetAportesDeUsuario?tipFondo=${tipFondo}&codCuenta=${codCuenta}&fromDate=${fromDate}&toDate=${toDate}`
    );
  }
  public async postActualizarInfoUsuario(AfpUser) {
    return this.post("PostActualizarInfoUsuario", AfpUser);
  }
  public async postContactosUsuario(AfpUser: AfpUserServiceContact) {
    return this.post("postActualizarContactosUsuario", AfpUser);
  }
  public async getNotificacionesBalance(
    account: string,
    fundType: string
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `GetNotificacionesBalance?account=${account}&fundType=${fundType}`
    );
  }
}
